<template>
  <div
    :id="id"
    :class="className"
    :style="{height: height, width: width}"
  />
</template>

<script>
import resize from "../mixins/resize";
const echarts = require("echarts");

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "pie-chart",
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: "100%",
    },
    pieData: {
      type: Array,
      default: [              
          { value: 0, name: "紧急" },
          { value: 0, name: "隐患" },
          { value: 0, name: "通知" },
      ]
    },
    total: {
        type: Number,
        default: 0
    }
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(document.getElementById(this.id));
      this.chart.setOption({
        tooltip: {
          trigger: 'item',
          position: 'top'
        },
        series: [
          {
            type: "pie",
            radius: ["62%", "80%"],
            label: {
              position: "center",
              fontSize: 24,
              formatter: "{c|{c}}",
              textVerticalAlign: "middle",
              lineHeight: 60,
              rich: {
                c: {
                  fontSize: 24,
                  fontWeight: "bold",
                  color: "#333333",
                },
                b: {
                  fontSize: 18,
                  fontWeight: 400,
                  color: "#666666",
                },
              },
            },
            itemStyle: { // 此配置
                normal: {
                  borderWidth: 1,
                  borderColor: '#ffffff',
                },
            },
            data: this.pieData,
          },
        ],
      });
    },
    refresh() {
      //console.log(this.total)
        if (!this.chart) {
            console.error('chart is null');
            return ;
        }
        this.chart.setOption({
        tooltip: {
          trigger: 'item',
          position: 'top'
        },
        series: [
          {
            type: "pie",
            radius: ["62%", "80%"],
            label: {
              position: "center",
              fontSize: 24,
              formatter: "{c|{c}}",
              textVerticalAlign: "middle",
              lineHeight: 60,
              rich: {
                c: {
                  fontSize: 24,
                  fontWeight: "bold",
                  color: "#333333",
                },
                b: {
                  fontSize: 18,
                  fontWeight: 400,
                  color: "#666666",
                },
              },
            },
            itemStyle: { // 此配置
                normal: {
                  borderWidth: 1,
                  borderColor: '#ffffff',
                },
            },
            data: this.pieData,
          },
        ],
      })
    }
  },
  watch: {
    pieData: function (newData, oldData) {
        this.refresh()
    }
  }
};
</script>

<style lang="less" scoped>
body {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: chartreuse;
}
</style>
